module.exports = __webpack_public_path__ + "img/case_7.03fc1339.png";